import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HelperBoxModule } from '@core/components/helpers/box/box.module';


// components
import { PdfViewerComponent } from './pdf-viewer/pdf-viewer.component';

@NgModule({
    imports: [
        CommonModule,
        HelperBoxModule
    ],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
    declarations: [
        PdfViewerComponent,
    ],
    exports: [
        PdfViewerComponent,
    ],

})
export class CorePdfViwerModule { }
